import { Empty, Modal, Spin } from 'antd';
import { MutationError } from 'src/core/type';
import styles from './storyInsigth.module.scss';
import { BsBookmarkFill } from 'react-icons/bs';
import { IStoryInSight } from '@coreStory/type';

interface Props {
  visible: boolean;
  error: MutationError | null;
  storyInsights?: IStoryInSight[];
  isLoading: boolean | null;
  onCancel: () => void;
  isMobile?: boolean;
}

const StoryInsight = ({
  visible,
  error,
  storyInsights,
  isLoading,
  onCancel,
  isMobile = false,
}: Props) => {
  if (!visible) return null;

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className={styles.loadingContainer}>
          <Spin size="large" />
          <p>Loading recommended stories...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className={styles.errorContainer}>
          <Empty
            image={<BsBookmarkFill size={48} className={styles.errorIcon} />}
            description={
              <div className={styles.errorDescription}>
                <h3>Error Loading Recommended Stories</h3>
                <p>Failed to load recommended stories. Please try again.</p>
              </div>
            }
          />
        </div>
      );
    }

    if (!storyInsights || storyInsights.length === 0) {
      return (
        <div className={styles.emptyContainer}>
          <Empty
            image={<BsBookmarkFill size={48} className={styles.emptyIcon} />}
            description={
              <div className={styles.emptyDescription}>
                <h3>Nothing for show....</h3>
                <p>Please try again.</p>
              </div>
            }
          />
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div>
            <h3 className={styles.story_title} style={{ color: '#f1568f' }}>
              Total actions
            </h3>
            <ul className={styles.story_list}>
              {storyInsights.map((story) => (
                <li
                  key={`${story.InsightActionTitle}-${story.Numbers}`}
                  className={styles.story_item}>
                  <p className={styles.story_item_title}>
                    {story.InsightActionTitle}
                  </p>
                  <p className={styles.story_normal_number}>{story.Numbers}</p>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className={styles.story_title} style={{ color: '#9c1de8' }}>
              Unique actions
            </h3>
            <ul className={styles.story_list}>
              {storyInsights.map((story) => (
                <li
                  key={`${story.InsightActionTitle}-${story.UniqNumbers}`}
                  className={styles.story_item}>
                  <p className={styles.story_item_title}>
                    {story.InsightActionTitle}
                  </p>
                  <p className={styles.story_normal_unique_number}>
                    {story.UniqNumbers}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={isMobile ? '95%' : 800}
      className={styles.modal}
      centered>
      {renderContent()}
    </Modal>
  );
};

export default StoryInsight;
